module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[12]),
      expression: "getScreenSize < 2 && !delayedLoading[12]"
    }],
    ref: "form",
    attrs: {
      "label-position": "top",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Format')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.format),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "format", $$v)
      },
      expression: "getSettingsAudioRecording.format"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Wav",
      "value": "wav"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Mp3",
      "value": "mp3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Raw",
      "value": "raw"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Ogg Vorbis",
      "value": "ogg"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Audio Offset')
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 30
    },
    model: {
      value: (_vm.getSettingsAudioRecording.offset),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "offset", $$v)
      },
      expression: "getSettingsAudioRecording.offset"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Day')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration1Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration1Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration1Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration1", $$v)
      },
      expression: "getSettingsAudioRecording.duration1"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold1type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold1type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold1type == 0 || _vm.getSettingsAudioRecording.threshold1type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold1, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold1[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold1type == 0 || _vm.getSettingsAudioRecording.threshold1type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold1[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold1, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold1[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1", $$v)
      },
      expression: "getSettingsAudioRecording.time1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1stop", $$v)
      },
      expression: "getSettingsAudioRecording.time1stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Night')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration2Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration2Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration2Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration2),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration2", $$v)
      },
      expression: "getSettingsAudioRecording.duration2"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold2type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold2type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold2type == 0 || _vm.getSettingsAudioRecording.threshold2type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold2, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold2[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold2type == 0 || _vm.getSettingsAudioRecording.threshold2type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold2[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold2, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold2[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1stop", $$v)
      },
      expression: "getSettingsAudioRecording.time1stop"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time1),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time1", $$v)
      },
      expression: "getSettingsAudioRecording.time1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Optional 1')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration3Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration3Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration3Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration3),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration3", $$v)
      },
      expression: "getSettingsAudioRecording.duration3"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold3type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold3type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold3type == 0 || _vm.getSettingsAudioRecording.threshold3type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold3, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold3[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold3type == 0 || _vm.getSettingsAudioRecording.threshold3type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold3[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold3, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold3[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time3),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time3", $$v)
      },
      expression: "getSettingsAudioRecording.time3"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time3stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time3stop", $$v)
      },
      expression: "getSettingsAudioRecording.time3stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('noise'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Optional 2')
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration4Picker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration4Picker", $$v)
      },
      expression: "getSettingsAudioRecording.duration4Picker"
    }
  }), _vm._v(" "), _c('el-input-number', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 3600
    },
    model: {
      value: (_vm.getSettingsAudioRecording.duration4),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "duration4", $$v)
      },
      expression: "getSettingsAudioRecording.duration4"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Threshold')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4type),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "threshold4type", $$v)
      },
      expression: "getSettingsAudioRecording.threshold4type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold4type == 0 || _vm.getSettingsAudioRecording.threshold4type == 2,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold4, 0, $$v)
      },
      expression: "getSettingsAudioRecording.threshold4[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsAudioRecording.threshold4type == 0 || _vm.getSettingsAudioRecording.threshold4type == 1,
      "min": -10,
      "max": 150,
      "step": 0.1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.threshold4[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording.threshold4, 1, $$v)
      },
      expression: "getSettingsAudioRecording.threshold4[1]"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Start')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time4),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time4", $$v)
      },
      expression: "getSettingsAudioRecording.time4"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Stop')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "max": 24,
      "step": 1
    },
    model: {
      value: (_vm.getSettingsAudioRecording.time4stop),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsAudioRecording, "time4stop", $$v)
      },
      expression: "getSettingsAudioRecording.time4stop"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[6]) ? _c('el-collapse', [_c('el-collapse-item', {
    class: _vm.getClass('weather'),
    attrs: {
      "title": _vm.$l('settings/audioRecording/Weather')
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[7]) ? _c('el-row', [_c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/RecDur')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:05 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsWeather.rectimePicker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "rectimePicker", $$v)
      },
      expression: "getSettingsWeather.rectimePicker"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.getSettingsWeather.rectime),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "rectime", $$v)
      },
      expression: "getSettingsWeather.rectime"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[8]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Windspeed')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "windsptrigtype", $$v)
      },
      expression: "getSettingsWeather.windsptrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.windsptrigtype == 0 || _vm.getSettingsWeather.windsptrigtype == 2,
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.windsptrig, 0, $$v)
      },
      expression: "getSettingsWeather.windsptrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.windsptrigtype == 0 || _vm.getSettingsWeather.windsptrigtype == 1,
      "min": 0,
      "max": 150
    },
    model: {
      value: (_vm.getSettingsWeather.windsptrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.windsptrig, 1, $$v)
      },
      expression: "getSettingsWeather.windsptrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[9]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Temperature')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.temptrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "temptrigtype", $$v)
      },
      expression: "getSettingsWeather.temptrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.temptrigtype == 0 || _vm.getSettingsWeather.temptrigtype == 2,
      "min": -40,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.temptrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.temptrig, 0, $$v)
      },
      expression: "getSettingsWeather.temptrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.temptrigtype == 0 || _vm.getSettingsWeather.temptrigtype == 1,
      "min": -40,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.temptrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.temptrig, 1, $$v)
      },
      expression: "getSettingsWeather.temptrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[10]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Air')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "airprtrigtype", $$v)
      },
      expression: "getSettingsWeather.airprtrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.airprtrigtype == 0 || _vm.getSettingsWeather.airprtrigtype == 2,
      "min": 300,
      "max": 1200
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.airprtrig, 0, $$v)
      },
      expression: "getSettingsWeather.airprtrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.airprtrigtype == 0 || _vm.getSettingsWeather.airprtrigtype == 1,
      "min": 300,
      "max": 1200
    },
    model: {
      value: (_vm.getSettingsWeather.airprtrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.airprtrig, 1, $$v)
      },
      expression: "getSettingsWeather.airprtrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[11]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Humidity')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "humidtrigtype", $$v)
      },
      expression: "getSettingsWeather.humidtrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.humidtrigtype == 0 || _vm.getSettingsWeather.humidtrigtype == 2,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.humidtrig, 0, $$v)
      },
      expression: "getSettingsWeather.humidtrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.humidtrigtype == 0 || _vm.getSettingsWeather.humidtrigtype == 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.humidtrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.humidtrig, 1, $$v)
      },
      expression: "getSettingsWeather.humidtrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[12]) ? _c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/audioRecording/Precipitation')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrigtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather, "precipittrigtype", $$v)
      },
      expression: "getSettingsWeather.precipittrigtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Disable'),
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Lower'),
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Greater'),
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/audioRecording/Both'),
      "value": 3
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/lowerThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.precipittrigtype == 0 || _vm.getSettingsWeather.precipittrigtype == 2,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrig[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.precipittrig, 0, $$v)
      },
      expression: "getSettingsWeather.precipittrig[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "sm": 2,
      "lg": 2
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": " "
    }
  }, [_vm._v("-")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 11,
      "lg": 11
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full pixel",
    attrs: {
      "label": _vm.$l('settings/audioRecording/greaterThan')
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsWeather.precipittrigtype == 0 || _vm.getSettingsWeather.precipittrigtype == 1,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.getSettingsWeather.precipittrig[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsWeather.precipittrig, 1, $$v)
      },
      expression: "getSettingsWeather.precipittrig[1]"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263a8252","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/AudioRecording.vue
// module id = 449
// module chunks = 1